var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEMailFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.654663,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF0000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.44226H6C5.86739 7.44226 5.74021 7.49717 5.64645 7.59492C5.55268 7.69267 5.5 7.82524 5.5 7.96347V16.8241C5.5 17.1006 5.60536 17.3657 5.79289 17.5612C5.98043 17.7567 6.23478 17.8665 6.5 17.8665H17.5C17.7652 17.8665 18.0196 17.7567 18.2071 17.5612C18.3946 17.3657 18.5 17.1006 18.5 16.8241V7.96347C18.5 7.82524 18.4473 7.69267 18.3536 7.59492C18.2598 7.49717 18.1326 7.44226 18 7.44226ZM12 12.9899L7.28562 8.48469H16.7144L12 12.9899ZM10.1694 12.6544L6.5 16.1602V9.14858L10.1694 12.6544ZM10.9094 13.3613L11.6594 14.0812C11.7516 14.1695 11.8723 14.2185 11.9975 14.2185C12.1227 14.2185 12.2434 14.1695 12.3356 14.0812L13.0856 13.3613L16.7106 16.8241H7.28562L10.9094 13.3613ZM13.8306 12.6544L17.5 9.14793V16.1609L13.8306 12.6544Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMailFooter);
export default __webpack_public_path__ + "static/media/e-mail-footer.1a47b8f5d26c282ed62b2c1b003a612d.svg";
export { ForwardRef as ReactComponent };